module.exports = __webpack_public_path__ + "img/building-medium.903b2bc2.png";